import { toast } from "sonner";
import { PhoneCallIcon, PhoneCallStopIcon } from "../../icons/phone";
import React, { useEffect, useRef, useState } from "react";

export const CallButton = () => {
  const [ongoing, setOngoing] = useState(false);
  const [audioURL, setAudioURL] = useState("");
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Uint8Array[]>([]);

  // Инициализация dataWriter (если нужно)
  useEffect(() => {
    // Очистка предыдущих данных
    // dataWriter.data.voice.audio = Buffer.from([]);
    return () => {
      if (mediaRecorderRef.current && ongoing) {
        mediaRecorderRef.current.stop();
      }
    };
  }, []);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioChunksRef.current = [];
      
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'audio/webm; codecs=opus'
      });
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = async (event) => {
        if (event.data.size > 0) {
          console.log("Буфер:", await event.data.arrayBuffer())
          const chunk = new Uint8Array(await event.data.arrayBuffer());
          audioChunksRef.current.push(chunk);
        }
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current.map(chunk => 
          new Blob([chunk], { type: 'audio/webm' })
        ));
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudioURL(audioUrl);
      };

      mediaRecorder.start(100); // Записываем чанки каждые 100 мс
      setOngoing(true);
    } catch (error) {
      console.error("Ошибка доступа к микрофону:", error);
      toast("Разрешите доступ к микрофону и обновите страницу");
      setOngoing(false);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && ongoing) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
      setOngoing(false);
    }
  };

  const playRecording = () => {
    if (audioURL) {
      new Audio(audioURL).play();
    }
  };

  const initCall = () => {
    if (ongoing) {
        setOngoing(false);
        stopRecording();
        playRecording();
    } else {
        startRecording();
    }
  }

  return (
    <div className={`aBtn callButton gridCenter${ongoing ? " ongoing" : ""}`} onClick={initCall}>
      {ongoing ? (
        <PhoneCallStopIcon width={24} height={24} />
      ) : (
        <PhoneCallIcon width={24} height={24} />
      )}
    </div>
  );
};
